// extracted by mini-css-extract-plugin
export var asterisk = "Date-module--asterisk--d405d";
export var root = "Date-module--root--169fd";